(function () {
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function money(cents, currency) {
    return '$' + (cents / 100).toFixed(2) + ' ' + currency;
  }

  function buildDropdown(input) {
    var dropdown = document.createElement('div');
    dropdown.className = 'quivers-predictive-dropdown';
    dropdown.style.cssText = [
      'position:absolute', 'top:100%', 'left:0', 'right:0', 'margin-top:6px',
      'background:#fff', 'border:1px solid #e5e5e5', 'border-radius:12px',
      'box-shadow:0 12px 32px rgba(0,0,0,0.12)', 'z-index:9999', 'max-height:420px',
      'overflow-y:auto', 'display:none',
    ].join(';');
    var wrapper = input.closest('form') || input.parentElement;
    wrapper.style.position = 'relative';
    wrapper.appendChild(dropdown);
    return dropdown;
  }

  function renderResults(dropdown, products, query) {
    if (!products.length) {
      dropdown.innerHTML = '<div style="padding:16px;color:#666;">No products found for "' + query + '"</div>';
      dropdown.style.display = 'block';
      return;
    }
    dropdown.innerHTML = products.map(function (p) {
      var image = p.featured_image ? p.featured_image.url : (p.image || '');
      return (
        '<a href="' + p.url + '" style="display:flex;align-items:center;gap:12px;padding:10px 16px;text-decoration:none;color:inherit;border-bottom:1px solid #f0f0f0;">' +
          (image ? '<img src="' + image + '&width=80" width="48" height="48" style="object-fit:cover;border-radius:8px;flex-shrink:0;" alt="">' : '<div style="width:48px;height:48px;background:#f5f5f5;border-radius:8px;flex-shrink:0;"></div>') +
          '<div style="min-width:0;">' +
            '<div style="font-size:14px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + p.title + '</div>' +
            '<div style="font-size:13px;color:#666;">' + p.price_formatted + '</div>' +
          '</div>' +
        '</a>'
      );
    }).join('') + '<a href="/search?q=' + encodeURIComponent(query) + '" style="display:block;padding:12px 16px;text-align:center;font-size:14px;font-weight:600;color:#8c52ff;text-decoration:none;">View all results</a>';
    dropdown.style.display = 'block';
  }

  function search(input, dropdown) {
    var query = input.value.trim();
    if (query.length < 2) {
      dropdown.style.display = 'none';
      return;
    }
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,vendor,product_type')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var mapped = products.map(function (p) {
          return {
            title: p.title,
            url: p.url,
            featured_image: p.featured_image,
            price_formatted: p.price ? ('$' + parseFloat(p.price).toFixed(2)) : '',
          };
        });
        renderResults(dropdown, mapped, query);
      })
      .catch(function () { dropdown.style.display = 'none'; });
  }

  function enhance(input) {
    if (input.dataset.quiversPredictiveEnhanced) return;
    input.dataset.quiversPredictiveEnhanced = 'true';
    var dropdown = buildDropdown(input);
    input.addEventListener('input', debounce(function () { search(input, dropdown); }, 250));
    document.addEventListener('click', function (e) {
      if (!dropdown.contains(e.target) && e.target !== input) dropdown.style.display = 'none';
    });
  }

  function init() {
    document.querySelectorAll('input[type="search"][name="q"]').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
